const $elements = document.querySelectorAll('[data-reveal]');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const defaultThreshold = 0.3;

// An element inside a [data-reveal-group] is revealed when the group becomes visible,
// so several elements can be chained with data-reveal-delay
function getTrigger($element) {
    return $element.closest('[data-reveal-group]') || $element;
}

if ($elements.length && !reducedMotion.matches) {
    const triggers = new Map();
    const observers = new Map();

    $elements.forEach(($element) => {
        const { revealDelay, revealDuration } = $element.dataset;
        const $trigger = getTrigger($element);

        if (revealDelay) {
            $element.style.setProperty('--reveal-delay', `${revealDelay}ms`);
        }
        if (revealDuration) {
            $element.style.setProperty('--reveal-duration', `${revealDuration}ms`);
        }
        $element.classList.add('is-reveal-ready');

        if (!triggers.has($trigger)) {
            triggers.set($trigger, []);
        }
        triggers.get($trigger).push($element);
    });

    triggers.forEach((elements, $trigger) => {
        const threshold = parseFloat($trigger.dataset.revealThreshold) || defaultThreshold;

        if (!observers.has(threshold)) {
            observers.set(threshold, new IntersectionObserver((entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        triggers.get(entry.target).forEach(($element) => {
                            $element.classList.add('is-revealed');
                        });
                        observer.unobserve(entry.target);
                    }
                });
            }, { threshold }));
        }
        observers.get(threshold).observe($trigger);
    });
}
